import { RefApi } from './types'

import { cyclicTabbingRefs } from './features/cyclicTabbing/cyclicTabbingRefs'
import { reporterRefs } from './features/reporter/reporterRefs'
import { businessLoggerRefs } from './features/businessLogger/businessLoggerRefs'
import { routerRefs } from './features/router/routerRefs'
import { envRefs } from './features/env/envRefs'
import { sessionRefs } from './features/session/sessionRefs'
import { seoRefs } from './features/seo/seoRefs'
import { siteScrollBlockerRefs } from './features/siteScrollBlocker/siteScrollBlockerRefs'
import { siteMembersRefs } from './features/siteMembers/siteMembersRefs'
import { navigationRefs } from './features/navigation/navigationRefs'
import { multilingualRefs } from './features/multilingual/multilingualRefs'
import { menuContainerRefs } from './features/menuContainer/menuContainerRefs'
import { consentPolicyRefs } from './features/consentPolicy/consentPolicyRefs'
import { triggersAndReactionsRefs } from './features/triggersAndReactions/triggersAndReactionsRefs'
import { lightboxRefs } from './features/lightbox/lightboxRefs'

export const refApi: RefApi = {
	router: routerRefs,
	env: envRefs,
	session: sessionRefs,
	reporter: reporterRefs,
	businessLogger: businessLoggerRefs,
	cyclicTabbing: cyclicTabbingRefs,
	seo: seoRefs,
	siteScrollBlocker: siteScrollBlockerRefs,
	siteMembers: siteMembersRefs,
	navigation: navigationRefs,
	multilingual: multilingualRefs,
	menuContainer: menuContainerRefs,
	consentPolicy: consentPolicyRefs,
	triggersAndReactions: triggersAndReactionsRefs,
	lightbox: lightboxRefs,
}

export type { RefApi, RefApiValues, ValuesToRefs } from './types'
